import React from 'react'
import {Button, Col, Row} from 'react-bootstrap';

import {dayMonthYearAtTimeWithSeconds} from '../../utils/dates';
import {ALERT_TITLE, AlertTypeSelector} from "./Select/AlertSelect";
import AlertNameSelect from "./Select/AlertNameSelect";
import {DateRangeSelector} from "../../component/Date/DateRangeSelector";
import moment from "moment/moment";

class AlertsGridTemplate {

  title = 'Alertas gerados';

  exportNewPage = true;

  showNewButton = false;

  showPdfButton = false;
  customFilters = {
    startDate: moment().subtract(7, 'days').toDate(), endDate: new Date()
  }

  customFilterComponent = (props, state, onChange) => {
    return (
      <div>
        <Row>
          <Col md={4}>
            <AlertTypeSelector
              setValue={selectedValue => {
                this.customFilters.alertType = selectedValue;
                onChange(this.customFilters)
              }}
            />
          </Col>
          <Col md={4}>
            <AlertNameSelect
              setValue={selectedValue => {
                this.customFilters.alertName = selectedValue;
                onChange(this.customFilters)
              }}
            />
          </Col>
          <Col sm={4}>
            <DateRangeSelector
              onChange={(startDate, endDate) => {
                this.customFilters.startDate = startDate;
                this.customFilters.endDate = endDate;
                onChange({...this.customFilters})
              }}
              defaultStartDate={this.customFilters.startDate}
            />
          </Col>
        </Row>
      </div>
    )
  };

  columns = [
    {
      Header: "Nome",
      accessor: "alertConfiguration.friendlyName"
    },
    {
      Header: "Tipo",
      accessor: "alertConfiguration.type",
      Cell: row => row.original && row.original.alertConfiguration && ALERT_TITLE[row.original.alertConfiguration.type] || 'Tipo não encontrado'
    },
    {
      Header: "Data",
      accessor: "createdAt",
      Cell: row => row.original && dayMonthYearAtTimeWithSeconds(row.original.createdAt)
    },
    {
      Header: "Ações",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => <Row className="justify-content-center">
        <Button bsStyle="secondary" href={`#/alert/detail/${row.original.id}`}>Ver detalhes</Button>
      </Row>
    }
  ];

  endpoint = () => {
    const params = new URLSearchParams({});
    this.customFilters.alertType && params.append('alertType',
      this.customFilters.alertType);
    this.customFilters.alertName && params.append('alertName',
      this.customFilters.alertName);

    this.customFilters.startDate && params.append('startDate',
      this.customFilters.startDate.toISOString());
    this.customFilters.endDate && params.append('endDate',
      this.customFilters.endDate.toISOString());

    return `alerts/v1/alerts?${params.toString()}`
  }
}

export {AlertsGridTemplate}



// WEBPACK FOOTER //
// ./src/pages/Alerts/AlertsGridTemplate.js